import React from "react";
import "./index.css";

// ScrollAnimation component (reusing the same approach)
class ScrollAnimation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isVisible: false,
    };
    this.domRef = React.createRef();
  }

  componentDidMount() {
    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        this.setState({ isVisible: true });
        observer.unobserve(this.domRef.current);
      }
    });

    observer.observe(this.domRef.current);
  }

  render() {
    const { children, stagger } = this.props;
    const staggerClass = stagger ? `stagger-${stagger}` : "";

    return (
      <div
        className={`portfolio-scroll-animation ${
          this.state.isVisible ? "is-visible" : ""
        } ${staggerClass}`}
        ref={this.domRef}
      >
        {children}
      </div>
    );
  }
}

class Portfolio extends React.Component {
  handleScroll = (e) => {
    e.preventDefault();
    const href = e.currentTarget.getAttribute("href") || "";
    const targetId = href.replace("#", "");
    const element = document.getElementById(targetId);

    if (element) {
      const yOffset = -80; // Adjust based on navbar height
      const y =
        element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  render() {
    const businesses = [
      {
        name: "Crawling to Destiny",
        id: "Crawling",
        location: "C2D - Early Childhood Development",
        description:
          "Providing infant and preschool childcare that nurtures early development. Our safe, enriching programs support learning, growth, and school readiness. Every child receives the care they need to thrive.",
        image:
          "https://images.unsplash.com/photo-1540479859555-17af45c78602?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
        website: "https://crawlingtodestiny.com/",
        icon: (
          <svg
            className="portfolio-icon"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
            />
          </svg>
        ),
        features: [
          "Child-Centered Learning",
          "Nurturing Environment",
          "Qualified Educators",
        ],
        primaryCta: {
          text: "Book a Consultation",
          href: "#appointment",
        },
        secondaryCta: {
          text: "Learn More",
          href: "https://crawlingtodestiny.com/",
        },
      },

      {
        name: "New Vision Behavioral Health Services",
        id: "newvision",
        location: "Compassionate Mental Health Services",
        description:
          "Providing counseling and wellness programs that support mental and emotional well-being. We offer compassionate, community-based care tailored to each individual. Helping families and individuals navigate life’s challenges with confidence.",
        image:
          "https://images.unsplash.com/photo-1607962837359-5e7e89f86776?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
        website: "https://nvbhoh.com/",
        icon: (
          <svg
            className="portfolio-icon"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
            />
          </svg>
        ),
        features: [
          "Evidence-Based Therapies",
          "Compassionate Care",
          "Personalized Medication Managment",
        ],
        primaryCta: {
          text: "Book a Consultation",
          href: "#appointment",
        },
        secondaryCta: {
          text: "Learn More",
          href: "https://nvbhoh.com/",
        },
      },

      {
        name: "Hitchcock Woods Learning",
        id: "hitchcock",
        location: "Premier Early Childhood Education",
        description:
          "Hitchcock Woods Learning Center delivers top-tier early childhood education in a caring, secure environment. We help children build a strong foundation through discovery, creativity, and developmental support.",
        image:
          "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
        website: "https://hitchcockwoodsctr.com/",
        icon: (
          <svg
            className="portfolio-icon"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
            />
          </svg>
        ),
        features: [
          "Holistic Development",
          "Creative Curriculum",
          "Safe Learning Environment",
        ],
        primaryCta: {
          text: "Book a Consultation",
          href: "#appointment",
        },
        secondaryCta: {
          text: "Learn More",
          href: "https://hitchcockwoodsctr.com/",
        },
      },

      {
        name: "Youngstown Event Center",
        id: "youngstown",
        location: "12 East Dewey Avenue, Youngstown, Ohio",
        description:
          "A vibrant venue for education, empowerment, and entertainment. From cultural events to business networking, we offer versatile spaces designed to bring the community together.",
        image:
          "https://images.unsplash.com/photo-1527529482837-4698179dc6ce?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
        website: "https://youngstowneventcenter.com/",
        icon: (
          <svg
            className="portfolio-icon"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
            />
          </svg>
        ),
        features: [
          "Versatile Event Spaces",
          "Professional Planning Team",
          "Customizable Packages",
        ],
        primaryCta: {
          text: "Contact Us Now",
          href: "#contact",
        },
        secondaryCta: {
          text: "Learn More",
          href: "https://youngstowneventcenter.com/",
        },
      },
    ];

    return (
      <section id="services" className="portfolio-section">
        {/* Decorative background elements */}
        <div className="portfolio-bg-gradient"></div>
        <div className="portfolio-bg-blob portfolio-bg-blob-bottom"></div>
        <div className="portfolio-bg-blob portfolio-bg-blob-top"></div>

        {/* Top wavy decoration */}
        <div className="portfolio-wave">
          <svg
            className="portfolio-wave-svg"
            viewBox="0 0 1200 120"
            preserveAspectRatio="none"
          >
            <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"></path>
          </svg>
        </div>

        <div className="portfolio-container">
          <ScrollAnimation>
            <div className="portfolio-header">
              <div className="portfolio-icon-circle">
                <svg
                  className="portfolio-header-icon"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1.5}
                    d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                  />
                </svg>
              </div>

              <h2 className="portfolio-title">
                Our{" "}
                <span className="portfolio-title-highlight">
                  Businesses
                  <span className="portfolio-title-underline"></span>
                </span>
              </h2>

              <p className="portfolio-subtitle">
                Discover the diverse portfolio of thriving businesses under the
                W.L.W. Enterprise umbrella. Each delivers exceptional service in
                its industry.
              </p>
            </div>
          </ScrollAnimation>

          <div className="portfolio-business-cards">
            {businesses.map((business, index) => (
              <ScrollAnimation key={index} stagger={(index % 2) + 1}>
                <div
                  className={`portfolio-business-card ${
                    index % 2 === 0
                      ? "portfolio-card-left"
                      : "portfolio-card-right"
                  }`}
                  onClick={() => window.open(business.website, "_blank")}
                  style={{ cursor: "pointer" }}
                >
                  <div className="portfolio-card-content">
                    {/* Image Side */}
                    <div className="portfolio-card-image-container">
                      <div className="portfolio-card-image-overlay"></div>
                      <img
                        src={business.image}
                        alt={business.name}
                        className="portfolio-card-image"
                      />

                      {/* Top left icon badge */}
                      <div className="portfolio-card-badge">
                        <div className="portfolio-card-badge-icon">
                          {business.icon}
                        </div>
                        <div className="portfolio-card-badge-dot"></div>
                      </div>
                    </div>

                    {/* Content Side */}
                    <div id={business.id} className="portfolio-card-info">
                      <div className="portfolio-card-text">
                        <div className="portfolio-card-header">
                          <h3 className="portfolio-card-title">
                            {business.name}
                          </h3>
                        </div>

                        <p className="portfolio-card-location">
                          <svg
                            className="portfolio-location-icon"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                            />
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                            />
                          </svg>
                          {business.location}
                        </p>

                        <p className="portfolio-card-description">
                          {business.description}
                        </p>

                        {/* Features */}
                        <div className="portfolio-card-features">
                          <h4 className="portfolio-features-title">
                            Business Highlights
                          </h4>
                          <div className="portfolio-features-list">
                            {business.features?.map((feature, i) => (
                              <div key={i} className="portfolio-feature-item">
                                <svg
                                  className="portfolio-feature-icon"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke="currentColor"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                                  />
                                </svg>
                                <span className="portfolio-feature-text">
                                  {feature}
                                </span>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>

                      <div className="portfolio-card-buttons">
                        <a
                          href={business.primaryCta.href}
                          onClick={(e) => {
                            e.stopPropagation(); // Prevent triggering the card's onClick
                            this.handleScroll(e);
                          }}
                          className="portfolio-primary-button"
                        >
                          <span className="portfolio-button-highlight"></span>
                          <span className="portfolio-button-overlay"></span>
                          <span className="portfolio-button-text">
                            {business.primaryCta.text}
                            <svg
                              className="portfolio-button-icon"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M14 5l7 7m0 0l-7 7m7-7H3"
                              />
                            </svg>
                          </span>
                        </a>

                        <a
                          href={business.secondaryCta.href}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="portfolio-secondary-button"
                          onClick={(e) => e.stopPropagation()} // Prevent triggering the card's onClick
                        >
                          <span className="portfolio-secondary-button-text">
                            {business.secondaryCta.text}
                          </span>
                        </a>
                      </div>
                    </div>
                  </div>

                  {/* Decorative accents for the card */}
                  <div className="portfolio-card-decoration portfolio-card-decoration-top"></div>
                  <div className="portfolio-card-decoration portfolio-card-decoration-bottom"></div>
                  <div className="portfolio-card-decoration portfolio-card-decoration-center"></div>
                </div>
              </ScrollAnimation>
            ))}
          </div>
        </div>
      </section>
    );
  }
}

export default Portfolio;
